export default Object.freeze({
  LOCALHOST: 'localhost',
  PROD: 'prod',
  STAGE: 'stage',
  DEV01: 'dev01',
  DEV02: 'dev02',
})
